import { Dropdown } from 'react-bootstrap';
import { User } from '../users.type';

type Props = {
  onEdit: (row: User) => void;
  onAccountStatusChange: (row: User) => void;
  onDelete: (row: User) => void;
  onInvite: (row: User) => void;
  row: User;
};

const ActionDropdownItems = ({
  onEdit,
  row,
  onAccountStatusChange,
  onDelete,
  onInvite
}: Props) => {
  const { isActive, isVerified } = row;
  const activeActiveLabel = isActive ? 'Deactivate' : 'Activate';
  return (
    <>
      <Dropdown.Item
        eventKey="1"
        disabled={isVerified}
        onClick={() => onEdit(row)}
      >
        Edit
      </Dropdown.Item>
      <Dropdown.Item
        eventKey="2"
        disabled={isVerified}
        onClick={() => onInvite(row)}
      >
        Send Invite
      </Dropdown.Item>
      <Dropdown.Item eventKey="3" onClick={() => onAccountStatusChange(row)}>
        {activeActiveLabel}
      </Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item
        eventKey="4"
        className={!isVerified ? 'text-danger' : ''}
        disabled={isVerified}
        onClick={() => onDelete(row)}
      >
        Delete
      </Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
